const BooleanData = [
  { value: "yes", name: "yes" },
  { value: "no", name: "no" },
];

export default BooleanData;
